export enum IPauseOrdersState {
  PAUSED = "paused",
  ONGOING = "ongoing",
  DISABLED = "disabled",
}
